import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import { Modal, message, Popover } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 75 },
    { key: 'orgName', label: '部门', width: 150 },
    { key: 'realName', label: '教师姓名', width: 120 },
    { key: 'courseName', label: '课程名称', width: 150 },
    { key: 'itemName', label: '评价指标' },
    { key: 'resultComment', label: '评语反馈' ,render: (value,row) =>
        <span> 
            <Popover placement="topLeft" style={{ width: 300 }}  content={
                <div style={{ width: 200 }}>
                    {
                        row.resultComment
                    }
                </div>} 
                title="评语反馈"
                >
                {value}
            </Popover>
        </span> 
    },
    {
        key: 'evalTime', label: '预提交日期', render: (date) => {
            return (date || "").split(' ')[0]
        }
    },
]);

const headers2 = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 75 },
    { key: 'orgName', label: '部门', width: 150 },
    { key: 'resultComment', label: '评语反馈' },
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('eval/result/listComments', keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method querySearchTarget
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTarget = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('eval/result/target/tree', keywords)
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}

/**
 * @method batchSubmit
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const batchSubmit = (id, data) => {
    return fetch.post('eval/result/batch/submit' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method batchBack
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const batchBack = (id, data) => {
    return fetch.post('eval/result/batch/back' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('eval/result/update' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('eval/result/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if (DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText: "确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if (response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result' + url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if (DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText: "确认",
        });
    } else {
        redirect('/update/' + DataGrid.selections[0]);
    }
}

const getSelection = () => {
    return DataGrid.selections;
}

const removeComment = (ids) => {
    return fetch.post(`eval/result/removeComment`, ids)
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('eval/result/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
    });
}

const aiAnalysisComments = (param) => {
    return fetch.post(`eval/result/aiAnalysisComments`, param)
}

export default {
    querySearch,
    querySearchById,
    batchSubmit,
    batchBack,
    update,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    querySearchTarget,
    getSelection,
    delete: removeComment,
    aiAnalysisComments
}